import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import * as serviceWorker from './serviceWorker';
import App from './App';

// Embed mode (website widget iframe via ?embed=1): tag <html> so embed-only CSS can hide
// redundant chrome (e.g. the account icon). No effect on the standalone order page.
try {
    if (/[?&]embed=1(?:&|$)/.test(window.location.search)) {
        document.documentElement.classList.add('fon-embed');
    }
} catch (e) {}

ReactDOM.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
